import axios from 'axios';
import authHeader from './auth-header';

//const API_URL = 'http://localhost:8080/matrix-mlm/api/mlm/ma/';
const API_URL = 'https://www.edibleherbsstores.com/api/mlm/ma/';

class MemberAwardService {
  getAll(page, pageSize) {
    return axios.get(API_URL + `memberaward/all?page=${page}&size=${pageSize}`, { headers: authHeader() });
  }

  get(id) {
    return axios.get(API_URL + `memberaward/${id}`, { headers: authHeader() });
  }

  create(memberAward) {
    return axios.post(API_URL + `memberaward/cre`, {
      awardDate: memberAward.awardDate,
      memberId: memberAward.memberId,
      awardId: memberAward.awardId
    }, { headers: authHeader() });
  }

  update(id, memberAward) {
    return axios.put(API_URL + `memberaward/${id}/upd`, {
      id: memberAward.id,  
      awardDate: memberAward.awardDate,
      paid: memberAward.paid,
      paidBy: memberAward.paidBy,
      paymentDate: memberAward.paymentDate,
      memberId: memberAward.memberId,
      awardId: memberAward.awardId
    }, { headers: authHeader() });
  }

  delete(id) {
    return axios.delete(API_URL + `del/${id}`, { headers: authHeader() });
  }

  deleteAll() {
    return axios.delete(API_URL + `delall`, { headers: authHeader() });
  }

  getSalesByDate(startDate, endDate) {
    return axios.getMemberAwardsByDate(API_URL + `memberaward/${startDate}/${endDate}/date`, { headers: authHeader() });
  }

  getMemberAwardsByAwardId(id) {
    return axios.get(API_URL + `memberaward/${id}/award`, { headers: authHeader() });
  }

  getMemberAwardsByMemberId(memberId) {
    return axios.get(API_URL + `memberaward/${memberId}/member`, { headers: authHeader() });
  }

  getMemberAndAwardCount(memberId) {
    return axios.get(API_URL + `memberaward/${memberId}/memberandawardcount`, { headers: authHeader() });
  }

  getTotalMemberAwards() {
    return axios.get(API_URL + `memberaward/totalmemberawards`, { headers: authHeader() });
  }

}

export default new MemberAwardService();